export default function MenuBalanceIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.5 6.75H4.5C3.25736 6.75 2.25 7.75736 2.25 9V18C2.25 19.2426 3.25736 20.25 4.5 20.25H19.5C20.7426 20.25 21.75 19.2426 21.75 18V9C21.75 7.75736 20.7426 6.75 19.5 6.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M19.2825 6.74998V5.34373C19.2824 4.99883 19.2062 4.6582 19.0592 4.34615C18.9123 4.0341 18.6984 3.75832 18.4326 3.53849C18.1668 3.31866 17.8558 3.16019 17.5217 3.0744C17.1877 2.98861 16.8388 2.9776 16.5 3.04217L4.155 5.1492C3.6189 5.25136 3.13526 5.53741 2.78749 5.958C2.43972 6.37859 2.24963 6.90736 2.25 7.4531V9.74998"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M16.9619 12.0518C17.2483 11.9948 17.5456 12.024 17.8154 12.1357C18.0851 12.2475 18.3154 12.437 18.4775 12.6797C18.6398 12.9225 18.7266 13.208 18.7266 13.5C18.7266 13.8916 18.5709 14.267 18.2939 14.5439C18.017 14.8209 17.6416 14.9766 17.25 14.9766C16.958 14.9766 16.6725 14.8898 16.4297 14.7275C16.187 14.5654 15.9975 14.3351 15.8857 14.0654C15.774 13.7956 15.7448 13.4983 15.8018 13.2119C15.8587 12.9255 15.9996 12.6626 16.2061 12.4561C16.4126 12.2496 16.6755 12.1087 16.9619 12.0518Z"
        fill="black"
        stroke="black"
        strokeWidth="0.046875"
      />
    </svg>
  );
}
